import Vue from "vue";
import router from "@/router";
import om from "../api";
import get from "lodash/get";
import * as END_POINTS from "../config/constants/end-points";
import * as ACTIONS from "../config/constants/action-types";
import * as MUTATIONS from "../config/constants/mutation-types";
import * as ERRORS from "@/config/constants/error-paths";

export default {
  /**
   * Action disparada por el router en
   * cada actualización
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_ROUTE](context, payload) {
    context.commit(MUTATIONS.ON_ROUTE, payload);
    setTimeout(() => {
      // Detener loading al ingresar a ruta nueva
      // Lo hacemos en un timeout = 0 para hacer
      // al final del event loop
      context.commit(MUTATIONS.ON_IS_LOADING, false);
    }, 0);
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_IS_LOADING](context, payload) {
    context.commit(MUTATIONS.ON_IS_LOADING, payload);
  },
  /**
   * Action para mostrar notificaciones en el front
   * en modo "toast"
   * @param {Object} context
   * @param {Object} payload: {type: String ["info", "success", "alert"], message: String}
   */
  [ACTIONS.DO_NOTIFICATION_TOAST](context, payload) {
    context.commit(MUTATIONS.ON_NOTIFICATION_TOAST, payload);
    setTimeout(() => {
      // Luego de 3 segundos quitamos la notificacion
      context.dispatch(ACTIONS.DO_NOTIFICATION_TOAST_RESET);
    }, 3000);
  },
  [ACTIONS.DO_NOTIFICATION_TOAST_RESET](context) {
    context.commit(MUTATIONS.ON_NOTIFICATION_TOAST, {
      type: "",
      message: "",
      theme: ""
    });
  },
  /**
   * Action para mostrar notificaciones a través de un modal en el front
   * en modo "toast"
   * @param {Object} context
   * @param {Object} payload: {type: String ["info", "success", "alert"], message: String}
   */
  [ACTIONS.DO_NOTIFICATION_MODAL](context, payload) {
    context.commit(MUTATIONS.ON_NOTIFICATION_MODAL, payload);
    setTimeout(() => {
      // Luego de 4 segundos quitamos la notificacion
      context.dispatch(ACTIONS.DO_NOTIFICATION_MODAL_RESET);
    }, 4000);
  },
  [ACTIONS.DO_NOTIFICATION_MODAL_RESET](context) {
    context.commit(MUTATIONS.ON_NOTIFICATION_MODAL, {
      type: "",
      title: "",
      message: ""
    });
  },
  /**
   * Action genérico para llamadas a la API
   * Se debe pasar el endpoint, el action a ejecutar en caso
   * de éxito y el action en caso de error
   * @param {Object} context Vue Context
   * @param {endPoint, payload, doSuccess, doError} actionPayload
   */
  [ACTIONS.DO_REQUEST_API](context, { endPoint, payload, doSuccess, doError }) {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    om.request({ endPoint, payload })
      .then(response => {
        context.dispatch(doSuccess, response.data);
      })
      .catch(error => {
        context.dispatch(doError, error);
      })
      .finally(() => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
      });
  },
  /**
   * Actions disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} context
   */
  [ACTIONS.DO_LANDING]: (context, payload) => {
    // Indicar cargando
    context.commit(MUTATIONS.ON_IS_LOADING, true);

    // Llamamos al action genérico de request
    // y especificamos el action de éxito y el de error
    // junto con el endpoint + payload
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_OFERTA,
      doSuccess: ACTIONS.DO_LANDING_SUCCESS,
      doError: ACTIONS.DO_LANDING_ERROR,
      payload
    });
  },
  [ACTIONS.DO_LANDING_SUCCESS]: () => {
    // Request landing exitosa
    // Ir a paso 1
    router.push("paso1");
  },
  [ACTIONS.DO_LANDING_ERROR]: (context, payload) => {
    // Consulta landing con error
    Vue.$log.error(payload);
    // Mostrar mensaje de error
    context.dispatch(ACTIONS.DO_MENSAJE, "mensaje-4");
  },
  [ACTIONS.DO_FORZAR_DNE]: ({ commit }, payload) => {
    commit(MUTATIONS.ON_FORZAR_DNE, payload);
  },
  [ACTIONS.DO_PASO1]: (context, payload) => {
    context.commit(MUTATIONS.ON_PASO_1, payload);
  },
  [ACTIONS.DO_SIN_PATENTE]: ({ getters, commit }) => {
    const {
      captcha,
      codigoPostal,
      domicilioParticular,
      numeroDoc,
      tipoDocumento
    } = getters.getConsulta();

    const apiPayload = {
      anio: String(new Date().getFullYear()),
      captcha,
      codigoPostal,
      domicilioParticular,
      numeroDoc,
      tipoDocumento,
      patente: ""
    };

    commit(MUTATIONS.ON_LIMPIAR_DATOS_PATENTE, apiPayload);
    commit(MUTATIONS.ON_IS_LOADING, false);
    router.push("condicion");
  },

  /**
   * Consulta si tiene patente
   * @param {Object} context
   * @param {Object} payload Código del mensaje
   */
  [ACTIONS.DO_PATENTE]: (context, payload) => {
    context.dispatch(ACTIONS.DO_CONSULTA_DATOS_PATENTE, {
      patente: payload.patente
    });

    context.commit(MUTATIONS.ON_IS_LOADING, true);
  },
  [ACTIONS.DO_CONDICION]: (context, payload) => {
    if (payload.condicion === "S") {
      payload.anio = String(new Date().getFullYear());
    }
    context.commit(MUTATIONS.ON_CONDICION, payload);
    router.push("marca");
  },
  [ACTIONS.DO_MARCA]: () => {
    router.push("modelo");
  },
  [ACTIONS.DO_MODELO]: () => {
    router.push("version");
  },
  [ACTIONS.DO_VERSION]: () => {
    router.push("gnc");
  },
  [ACTIONS.DO_GNC]: () => {
    router.push("guardado");
  },
  [ACTIONS.DO_RESUMEN]: () => {
    router.push("guardado");
  },
  /**
   * Consulta si es cliente
   * @param {Object} context
   * @param {Object} payload Código del mensaje
   */
  [ACTIONS.DO_CONSULTA_ES_CLIENTE]: ({ state, commit, dispatch }, payload) => {
    payload.tcode = state.tcode;
    commit(MUTATIONS.ON_IS_LOADING, true);
    om.consulta(payload)
      .then(async response => {
        let respuesta = response.data;
        if (
          get(respuesta, "status", "ERROR") === "ERROR" ||
          get(respuesta, "respuesta.mensaje", "ok") === "error"
        ) {
          commit(MUTATIONS.ON_IS_LOADING, false);
          dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
          commit(MUTATIONS.ON_ERROR, respuesta);
          return;
        }

        let esCliente = response.data.respuesta;
        if (esCliente) {
          // Avanzamos normalmente
          await dispatch(ACTIONS.DO_GET_TOKEN_USER_ID, {
            nroDoc: payload.claIden,
            tipoDoc: payload.codIden
          });
          router.push("paso2");
        } else {
          // Muestra pantalla de deteccion no cliente
          router.push({
            name: "loading",
            params: {
              mje: "mensaje-14"
            }
          });
          //Redireccion
          setTimeout(function () {
            window.location = `${
              process.env["VUE_APP_PAGINA_SEGUROS_" + _BBVA_CAMP]
            }`;
          }, 5000);
        }
      })
      .catch(error => {
        commit(MUTATIONS.ON_IS_LOADING, false);
        dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
        commit(MUTATIONS.ON_ERROR, error);
      });
  },
  [ACTIONS.DO_PASO2]: (context, payload) => {
    context.commit(MUTATIONS.ON_PASO_2, payload);
  },
  [ACTIONS.DO_GRACIAS]: (context, payload) => {
    context.commit(MUTATIONS.ON_GRACIAS, payload);
  },
  /**
   * Mostrar un mensaje de error
   * @param {Object} context
   * @param {Object} payload Código del mensaje
   */
  [ACTIONS.DO_MENSAJE]: (context, payload) => {
    router.push({
      name: "mensaje",
      params: {
        mje: payload
      }
    });
  },
  [ACTIONS.DO_MERLIN]: ({ commit, state }, payload) => {
    commit(MUTATIONS.ON_IS_LOADING, true);
    let domicilioMerlin = Object.assign({}, payload);
    const payloadMerlin = {
      domicilio: {
        calle: get(domicilioMerlin, "calle"),
        numero: get(domicilioMerlin, "numero"),
        localidad: get(domicilioMerlin, "localidad"),
        provincia: get(domicilioMerlin, "provincia")
      }
    };
    om.merlin(payloadMerlin)
      .then(response => {
        let respuesta = response.data;
        if (!respuesta.respuesta.validMerlin) {
          commit(MUTATIONS.ON_ERROR_MERLIN, {
            error: respuesta.respuesta.motivo,
            valido: false
          });
        } else {
          let codigoPostal = respuesta.respuesta.domicilio.codigoPostal;
          commit(MUTATIONS.ON_ERROR_MERLIN, { error: "", valido: true });
          state.consulta.codigoPostal = codigoPostal;
        }
      })
      .catch(() => {
        commit(MUTATIONS.ON_ERROR_MERLIN, {
          error: "Error al contactar al Servicio, intente nuevamente",
          valido: false
        });
      })
      .finally(() => {
        commit(MUTATIONS.ON_IS_LOADING, false);
      });
  },
  [ACTIONS.DO_LANDING_PLANES]: (context, payload) => {
    const {
      anio,
      codigoPostal,
      gnc,
      numeroDoc,
      tipoDocumento,
      codigoProvincia,
      condicion,
      marca,
      modelo,
      version,
      patente
    } = payload;

    const apiPayload = {
      TipoDocumento: tipoDocumento,
      NumeroDocumento: numeroDoc,
      CodigoProvincia: codigoProvincia,
      CodigoPostal: codigoPostal,
      Telefono: "",
      Email: "",
      Anio: anio,
      DescripcionMarca: context.state.marcasAuto.find(
        item => item.codMarca === marca
      ).descripcionMarca,
      DescripcionModelo: context.state.modelosAuto.find(
        item => item.codModelo === modelo
      ).descripcionModelo,
      DescripcionSubmodelo: context.state.versionesAuto.find(
        item => item.codSubmodelo === version
      ).descripcionSubmodelo,
      IndicadorCeroKilometros: condicion,
      IndicadorGnc: gnc,
      Uso: "P",
      IndicadorCompania: "09",
      IndicadorAdicional1: " ",
      ImporteAdicional1: "0",
      IndicadorAdicional2: " ",
      ImporteAdicional2: "0",
      IndicadorAdicional3: " ",
      ImporteAdicional3: "0",
      IndicadorAdicional4: " ",
      ImporteAdicional4: "0",
      IndicadorAdicional5: " ",
      ImporteAdicional5: "0",
      Patente: patente
    };
    context.dispatch(ACTIONS.DO_CONSULTA_SIMULACION, apiPayload);
  },
  [ACTIONS.DO_CONSULTA_DATOS_PATENTE]: ({ dispatch, commit }, payload) => {
    // Llamada al backend para obtener los datos de una patente
    commit(MUTATIONS.ON_IS_LOADING, true);
    dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_DATOS_PATENTE,
      payload,
      doSuccess: ACTIONS.DO_CONSULTA_DATOS_PATENTE_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_DATOS_PATENTE_ERROR
    });
  },
  [ACTIONS.DO_CONSULTA_DATOS_PATENTE_SUCCESS]: (
    { commit, dispatch, getters },
    payload
  ) => {
    commit(MUTATIONS.ON_IS_LOADING, true);
    if (payload.status === "ERROR") {
      dispatch(ACTIONS.DO_CONSULTA_DATOS_PATENTE_ERROR);
      Vue.$log.error(payload);
    } else {
      const { anio, codMarca, codModelo, codSubmodelo } = payload.respuesta;
      const {
        captcha,
        codigoPostal,
        domicilioParticular,
        numeroDoc,
        patente,
        tipoDocumento
      } = getters.getConsulta();

      const apiPayload = {
        anio,
        captcha,
        codigoPostal,
        condicion: anio === new Date().getFullYear() ? "S" : "N",
        domicilioParticular,
        gnc: "G0",
        marca: codMarca,
        modelo: codModelo,
        numeroDoc,
        patente,
        tipoDocumento,
        version: codSubmodelo
      };
      commit(MUTATIONS.ON_CONSULTA_DATOS_PATENTE, apiPayload);
      dispatch(ACTIONS.DO_CONSULTA_MARCAS);
      dispatch(ACTIONS.DO_CONSULTA_MODELOS, { codMarca, anio });
      dispatch(ACTIONS.DO_CONSULTA_VERSION, { codMarca, codModelo, anio });
      router.push("resumen");
    }
  },
  [ACTIONS.DO_CONSULTA_DATOS_PATENTE_ERROR]: ({ commit, getters }) => {
    const {
      captcha,
      codigoPostal,
      domicilioParticular,
      numeroDoc,
      patente,
      tipoDocumento
    } = getters.getConsulta();

    const apiPayload = {
      anio: String(new Date().getFullYear()),
      captcha,
      codigoPostal,
      domicilioParticular,
      numeroDoc,
      patente,
      tipoDocumento
    };

    commit(MUTATIONS.ON_LIMPIAR_DATOS_PATENTE, apiPayload);
    commit(MUTATIONS.ON_IS_LOADING, false);
    router.push("condicion");
  },
  [ACTIONS.DO_CONSULTA_MARCAS]: ({ dispatch, state, commit }) => {
    // Llamada al backend para consultar marcas
    if (state.marcasAuto.length === 0) {
      commit(MUTATIONS.ON_IS_LOADING, true);
      dispatch(ACTIONS.DO_REQUEST_API, {
        endPoint: END_POINTS.CONSULTAR_MARCAS_AUTO,
        payload: {},
        doSuccess: ACTIONS.DO_CONSULTA_MARCAS_SUCCESS,
        doError: ACTIONS.DO_CONSULTA_MARCAS_ERROR
      });
    }
  },
  [ACTIONS.DO_CONSULTA_MARCAS_SUCCESS]: ({ commit, dispatch }, payload) => {
    commit(MUTATIONS.ON_IS_LOADING, false);
    if (payload.status === "ERROR") {
      dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    } else {
      commit(MUTATIONS.ON_CONSULTA_MARCAS_AUTO, payload.respuesta);
    }
  },
  [ACTIONS.DO_CONSULTA_MARCAS_ERROR]: ({ commit, dispatch }, payload) => {
    Vue.$log.error(payload);
    commit(MUTATIONS.ON_IS_LOADING, false);
    dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
  },
  [ACTIONS.DO_CONSULTA_MODELOS]: ({ commit, dispatch }, payload) => {
    // Llamada al backend para consultar modelos
    commit(MUTATIONS.ON_IS_LOADING, true);
    dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_MODELOS_AUTO,
      payload,
      doSuccess: ACTIONS.DO_CONSULTA_MODELOS_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_MODELOS_ERROR
    });
  },
  [ACTIONS.DO_CONSULTA_MODELOS_SUCCESS]: ({ commit, dispatch }, payload) => {
    commit(MUTATIONS.ON_IS_LOADING, false);
    if (payload.status === "ERROR") {
      dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    } else {
      commit(MUTATIONS.ON_CONSULTA_MODELOS_AUTO, payload.respuesta);
    }
  },
  [ACTIONS.DO_CONSULTA_MODELOS_ERROR]: ({ commit, dispatch }, payload) => {
    Vue.$log.error(payload);
    dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    commit(MUTATIONS.ON_IS_LOADING, false);
  },
  [ACTIONS.DO_CONSULTA_VERSION]: ({ commit, dispatch }, payload) => {
    // Llamada al backend para consultar modelos
    commit(MUTATIONS.ON_IS_LOADING, true);
    dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_VERSION_AUTO,
      payload,
      doSuccess: ACTIONS.DO_CONSULTA_VERSION_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_VERSION_ERROR
    });
  },
  [ACTIONS.DO_CONSULTA_VERSION_SUCCESS]: ({ commit, dispatch }, payload) => {
    commit(MUTATIONS.ON_IS_LOADING, false);
    if (payload.status === "ERROR") {
      dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    } else {
      commit(MUTATIONS.ON_CONSULTA_VERSION_AUTO, payload.respuesta);
    }
  },
  [ACTIONS.DO_CONSULTA_VERSION_ERROR]: ({ commit, dispatch }, payload) => {
    Vue.$log.error(payload);
    dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    commit(MUTATIONS.ON_IS_LOADING, false);
  },

  [ACTIONS.DO_CONSULTA_VIVIENDA]: ({ commit, dispatch }, payload) => {
    // Llamada al backend para consultar modelos
    commit(MUTATIONS.ON_IS_LOADING, true);
    dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.OBTENER_TIPOS_VIVIENDA,
      payload,
      doSuccess: ACTIONS.DO_CONSULTA_VIVIENDA_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_VIVIENDA_ERROR
    });
  },
  [ACTIONS.DO_CONSULTA_VIVIENDA_SUCCESS]: ({ commit, dispatch }, payload) => {
    commit(MUTATIONS.ON_IS_LOADING, false);
    Vue.$log.info("payload");
    if (payload.status === "ERROR") {
      dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    } else {
      Vue.$log.info(payload.respuesta.tiposDeVivienda);
      commit(MUTATIONS.ON_CONSULTA_VIVIENDA, payload.respuesta.tiposDeVivienda);
    }
  },
  [ACTIONS.DO_CONSULTA_VIVIENDA_ERROR]: ({ commit, dispatch }, payload) => {
    Vue.$log.error(payload);
    dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    commit(MUTATIONS.ON_IS_LOADING, false);
  },

  [ACTIONS.DO_CONSULTA_SIMULACION]: ({ commit, dispatch }, payload) => {
    // Llamada al backend para obtener simulacion de la cotizacion
    commit(MUTATIONS.ON_IS_LOADING, true);
    dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_SIMULACION_COTIZACION,
      payload,
      doSuccess: ACTIONS.DO_CONSULTA_SIMULACION_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_SIMULACION_ERROR
    });
  },
  [ACTIONS.DO_CONSULTA_SIMULACION_SUCCESS]: ({ commit, dispatch }, payload) => {
    commit(MUTATIONS.ON_IS_LOADING, false);
    if (payload.status === "ERROR") {
      dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    } else {
      router.push("planes");
      commit(MUTATIONS.ON_CONSULTA_SIMULACION_COTIZACION, payload.respuesta);
    }
  },
  [ACTIONS.DO_CONSULTA_SIMULACION_ERROR]: ({ commit, dispatch }, payload) => {
    Vue.$log.error(payload);
    dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    commit(MUTATIONS.ON_IS_LOADING, false);
  },
  [ACTIONS.DO_RECOTIZACION_COBERTURA]: (
    { state, commit, dispatch },
    payload
  ) => {
    commit(MUTATIONS.ON_IS_LOADING, true);
    om.recotizacionCobertura(payload)
      .then(response => {
        let respuesta = response.data;
        if (
          get(respuesta, "status", "ERROR") === "ERROR" ||
          get(respuesta, "respuesta.mensaje", "ok") === "error"
        ) {
          commit(MUTATIONS.ON_IS_LOADING, false);
          dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
          commit(MUTATIONS.ON_ERROR, respuesta);
          return;
        }

        let recotizacion = response.data.respuesta;

        if (recotizacion) {
          // cambiar en el state las cotizaciones viejas por la nuevas
          state.cotizacionHogar = recotizacion;
        }
      })
      .catch(error => {
        commit(MUTATIONS.ON_IS_LOADING, false);
        dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
        commit(MUTATIONS.ON_ERROR, error);
      });
  },
  [ACTIONS.DO_COTIZACION_HOGAR]: ({ commit, dispatch }, payload) => {
    // Llamada al backend para consultar cotizacion}
    commit(MUTATIONS.ON_IS_LOADING, true);
    dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.OBTENER_COTIZACION_HOGAR,
      payload,
      doSuccess: ACTIONS.DO_COTIZACION_HOGAR_SUCCESS,
      doError: ACTIONS.DO_COTIZACION_HOGAR_ERROR
    });
  },
  [ACTIONS.DO_COTIZACION_HOGAR_SUCCESS]: ({ commit, dispatch }, payload) => {
    commit(MUTATIONS.ON_IS_LOADING, false);
    if (payload.status === "ERROR") {
      dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    } else {
      commit(MUTATIONS.ON_COTIZACION_HOGAR, payload.respuesta);
      router.push("paso3");
    }
  },
  [ACTIONS.DO_COTIZACION_HOGAR_ERROR]: ({ commit, dispatch }, payload) => {
    Vue.$log.error(payload);
    dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    commit(MUTATIONS.ON_IS_LOADING, false);
  },
  [ACTIONS.DO_RECOTIZACION_HOGAR]: ({ commit, dispatch }, payload) => {
    // Llamada al backend para consultar cotizacion
    commit(MUTATIONS.ON_IS_LOADING, true);
    dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.OBTENER_RECOTIZACION_HOGAR,
      payload,
      doSuccess: ACTIONS.DO_RECOTIZACION_HOGAR_SUCCESS,
      doError: ACTIONS.DO_RECOTIZACION_HOGAR_ERROR
    });
  },
  [ACTIONS.DO_RECOTIZACION_HOGAR_SUCCESS]: ({ commit, dispatch }, payload) => {
    commit(MUTATIONS.ON_IS_LOADING, false);
    if (payload.status === "ERROR") {
      dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    } else {
      commit(MUTATIONS.ON_RECOTIZACION_HOGAR, payload.respuesta);
    }
  },
  [ACTIONS.DO_RECOTIZACION_HOGAR_ERROR]: ({ commit, dispatch }, payload) => {
    Vue.$log.error(payload);
    dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    commit(MUTATIONS.ON_IS_LOADING, false);
  },
  [ACTIONS.DO_OBTENER_PDF_HOGAR]: async ({ commit, dispatch }, payload) => {
    // Llamada al backend para consultar cotizacion
    commit(MUTATIONS.ON_IS_LOADING, true);

    let listpdf = [];
    let pdfs = [];
    listpdf.push({
      urlPDFBase64: "",
      idForm: 1
    });

    let pdf = om.downloadPdf(payload);
    pdfs.push(pdf);

    try {
      const response = await Promise.all(pdfs);

      if (response[0].data.status === "ERROR") {
        commit(MUTATIONS.ON_IS_LOADING, false);
        dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
      } else {
        for (let i = 0; i < response.length; i++) {
          let binary = atob(response[i].data.respuesta.replace(/\s/g, ""));
          let len = binary.length;
          let buffer = new ArrayBuffer(len);
          let view = new Uint8Array(buffer);

          for (let j = 0; j < len; j++) {
            view[j] = binary.charCodeAt(j);
          }

          let blob = new Blob([view], { type: "application/pdf" });
          listpdf[i].urlPDFBase64 = URL.createObjectURL(blob);
        }

        window.open(listpdf[0].urlPDFBase64);
        commit(MUTATIONS.ON_OBTENER_PDF_HOGAR, listpdf[0].urlPDFBase64);
      }
    } catch (error) {
      dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
      commit(MUTATIONS.ON_ERROR, error);
    } finally {
      commit(MUTATIONS.ON_IS_LOADING, false);
    }
  },
  [ACTIONS.DO_OBTENER_PDF_HOGAR_SUCCESS]: ({ commit, dispatch }, payload) => {
    commit(MUTATIONS.ON_IS_LOADING, false);
    if (payload.status === "ERROR") {
      dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    } else {
      commit(MUTATIONS.ON_OBTENER_PDF_HOGAR, payload.respuesta);
    }
  },
  [ACTIONS.DO_OBTENER_PDF_HOGAR_ERROR]: ({ commit, dispatch }, payload) => {
    Vue.$log.error(payload);
    dispatch(ACTIONS.DO_MENSAJE, ERRORS.ERROR_TECNICO);
    commit(MUTATIONS.ON_IS_LOADING, false);
  },
  [ACTIONS.DO_GUARDAR_DESCRIPCION_VIVIENDA]: ({ commit }, payload) => {
    Vue.$log.info(payload);
    commit(MUTATIONS.ON_GUARDAR_DESCRIPCION_VIVIENDA, payload);
  },
  [ACTIONS.DO_COBERTURA_ANADIR]: ({ commit }, payload) => {
    Vue.$log.info(payload);
    commit(MUTATIONS.ON_COBERTURA_ANADIR, payload);
  },
  [ACTIONS.DO_COBERTURA_QUITAR]: (
    { state, commit },
    codigoCoberturaAniadida
  ) => {
    Vue.$log.info(codigoCoberturaAniadida);
    commit(
      MUTATIONS.ON_COBERTURA_QUITAR,
      state.coberturasAnadidas.filter(cobertura => {
        return cobertura.codigo !== codigoCoberturaAniadida;
      })
    );
  },
  [ACTIONS.DO_COBERTURA_QUITAR_TODAS]: ({ commit }) => {
    commit(MUTATIONS.ON_COBERTURA_QUITAR_TODAS);
  },
  [ACTIONS.DO_COBERTURAS_SELECCIONADAS]: ({ commit }, payload) => {
    commit(MUTATIONS.ON_COBERTURAS_SELECCIONADAS, payload);
  },
  [ACTIONS.DO_NORMALIZAR_CELULAR]: ({ commit }, payload) => {
    if (payload.status !== "CO") {
      commit(MUTATIONS.ON_NORMALIZAR_CELULAR, { valido: false });
    } else {
      const celularNormalizado = {
        area: Number(payload.ddn).toString(),
        nro: payload.fullCellPhoneNumber,
        caracteristica: payload.characteristic,
        valido: true
      };
      commit(MUTATIONS.ON_NORMALIZAR_CELULAR, celularNormalizado);
    }
  },
  [ACTIONS.DO_QUIERO_ME_CONTACTEN]: ({ dispatch, getters }, payload) => {
    const { numeroDoc, tipoDocumento } = getters.getConsulta();
    const { numero } = payload;

    const apiPayload = {
      telef: numero,
      tipDoc: tipoDocumento,
      nroDoc: numeroDoc
    };
    dispatch(ACTIONS.DO_POST_QUIERO_ME_CONTACTEN, apiPayload);
  },
  [ACTIONS.DO_POST_QUIERO_ME_CONTACTEN]: ({ commit, dispatch }, payload) => {
    commit(MUTATIONS.ON_IS_LOADING, true);
    dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.POST_QUIERO_ME_CONTACTEN,
      payload,
      doSuccess: ACTIONS.DO_POST_QUIERO_ME_CONTACTEN_SUCCESS,
      doError: ACTIONS.DO_POST_QUIERO_ME_CONTACTEN_ERROR
    });
  },
  [ACTIONS.DO_POST_QUIERO_ME_CONTACTEN_SUCCESS]: (
    { commit, dispatch },
    payload
  ) => {
    commit(MUTATIONS.ON_IS_LOADING, false);
    if (payload.status === "ERROR") {
      dispatch(ACTIONS.DO_NOTIFICATION_TOAST, {
        type: "alert",
        message: "No pudimos enviar tu número. Volvé a intentar.",
        theme: "light"
      });
    } else {
      dispatch(ACTIONS.DO_NOTIFICATION_MODAL, {
        type: "success",
        title: "¡Listo! Ingresaste tus datos",
        message:
          "Te vamos a llamar en las próximas 48 horas al número que ingresaste."
      });
    }
  },
  [ACTIONS.DO_POST_QUIERO_ME_CONTACTEN_ERROR]: (
    { commit, dispatch },
    payload
  ) => {
    Vue.$log.error(payload);
    dispatch(ACTIONS.DO_NOTIFICATION_TOAST, {
      type: "alert",
      message: "No pudimos enviar tu número. Volvé a intentar.",
      theme: "light"
    });
    commit(MUTATIONS.ON_IS_LOADING, false);
  },
  [ACTIONS.DO_GET_TOKEN_USER_ID]: (context, payload) => {
    return om
      .tokenizarUser(payload)
      .then(response => {
        let respuesta = response.data;
        if (respuesta.status === "OK") {
          let userIdTokenizado = respuesta.respuesta.customerID;
          context.commit(MUTATIONS.ON_USER_ID_TOKENIZADO, userIdTokenizado);
        }
      })
      .catch(error => {
        Vue.$log.error(error);
      });
  }
};
